import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of, combineLatest} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {catchError, map, tap} from 'rxjs/operators';
import {TranslateProvider} from './providers/translate-provider';

export interface ILocale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {

  constructor(
    private translate: TranslateService,
    private http: HttpClient
  ) {
  }

  getTranslation(lang: string): void {

    // console.log('get translation', lang);

    const project = JSON.parse(localStorage.getItem('project_id'));

    if (project && project.projectID) {
      combineLatest([
        TranslateProvider.getCommonTranslation(this.http, lang),
        this.getProjectDictionary(project!.projectID!.id, lang)
      ]).pipe(
        map(result => Object.assign({}, result[0], result[1])),
        tap(result => {
          this.translate.setTranslation(lang, result, true);
        })
      ).subscribe();
    } else {
      TranslateProvider.getCommonTranslation(this.http, lang).subscribe(result => {
        this.translate.setTranslation(lang, result, true);
      });
    }

  }

  getProjectDictionary(project_id, language) {
    const params = new HttpParams().append('project_id', project_id).append('language', language);
    return this.http.get(`/api2/member/project_dictionary`, {params}).pipe(
      catchError(() => [{'map': {}}]),
      map(res => res['map']),
      // tap(res => {console.log('translations loaded:', res)})
    );

  }

}
